module.exports = __webpack_public_path__ + "static/img/hzlc.eea653b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzlc.png
// module id = Wkkx
// module chunks = 0